import TiltifyIcon from "@/svg/tiltify-icon";
import { openTiltifyOAuthPopup } from "@/util/tiltifyHelper.ts";

export interface TiltifyOAuthCallbackUser {
  id: string;
  username: string;
  slug: string;
  tokens?: {
    accessToken?: string;
    refreshToken?: string;
    expiresIn?: string | number;
    createdAt?: string;
  };
}

interface TiltifyOAuthButtonProps {
  setTiltifyUser?: (user: TiltifyOAuthCallbackUser) => void;
}

/**
 * Handles the Tiltify OAuth button and login state. Login state is based on the presence of a username field.
 * @returns
 */
export function TiltifyOAuthButton({ setTiltifyUser = () => {} }: TiltifyOAuthButtonProps) {
  return (
    <div className="min-h-10">
      <div className="my-4">
        <button
          type="button"
          className="btn btn-secondary tiltify w-full"
          data-track="tiltify-oauth-setup"
          onClick={() =>
            openTiltifyOAuthPopup(
              setTiltifyUser as unknown as (user: Record<string, unknown>) => void,
            )
          }
        >
          Connect to Tiltify
          <TiltifyIcon classname="w-7 h-7 ml-2 mr-0 inline" />
        </button>
      </div>
    </div>
  );
}
